import React from "react";

export const ScheduleSidebar = () => {
  return (
    <div className="ScheduleSidebar">
      Schedule Sidebar
    </div>
  )
}
